// import React, { useState } from "react";
// import { observer } from "mobx-react";
// import { toJS } from "mobx";
// import { Modal, Button } from "react-bootstrap"; // Make sure you have react-bootstrap installed

// const LogTableBody = ({ logRaw }) => {
//   const [showModal, setShowModal] = useState(false);
//   const [selectedLog, setSelectedLog] = useState(null);
//   const logList = toJS(logRaw);

//   // Function to open modal and set selected log data
//   const handleViewClick = (log) => {
//     setSelectedLog(log);
//     setShowModal(true);
//   };

//   // Function to close modal
//   const handleCloseModal = () => {
//     setShowModal(false);
//     setSelectedLog(null);
//   };

//   // Function to render key-value pairs with proper design
//   const renderKeyValuePairs = (data, level = 0) => {
//     if (typeof data !== "object" || data === null) {
//       return null;
//     }

//     return Object.entries(data).map(([key, value], index) => (
//       <div
//         key={index}
//         style={{
//           marginBottom: "10px",
//           paddingLeft: `${level * 20}px`, // Indentation for nested objects
//           borderLeft: level > 0 ? "1px solid #ccc" : "none", // Add border for nested levels
//         }}
//       >
//         {/* <strong>{key.charAt(0).toUpperCase() + key.slice(1)}:</strong>{' '} */}
//         {!Number.isNaN(Number(key)) ? (
//           <span style={{ display: "none" }}>
//             {key.charAt(0).toUpperCase() + key.slice(1)}:
//           </span>
//         ) : (
//           <strong>{key.charAt(0).toUpperCase() + key.slice(1)}:</strong>
//         )}{" "}
//         <div>
//           {typeof value === "object" && value !== null ? (
//             <div
//               style={{
//                 backgroundColor: "#f8f9fa",
//                 padding: "10px",
//                 borderRadius: "5px",
//               }}
//             >
//               {renderKeyValuePairs(value, level + 1)}{" "}
//               {/* Recursively handle nested objects */}
//             </div>
//           ) : value !== null ? (
//             value
//           ) : (
//             "null"
//           )}
//         </div>
//       </div>
//     ));
//   };

//   return (
//     <>
//       <tbody>
//         {logList.length > 0 ? (
//           logList.map((log, index) => (
//             <tr key={index}>
//               <td>{log.user.firstName}</td>
//               <td>{new Date(log.createdAt).toLocaleDateString("en-GB")}</td>
//               <td>{log.action}</td>
//               <td>{log.ip}</td>
//               <td>
//                 <button onClick={() => handleViewClick(log.request)}>
//                   View
//                 </button>
//               </td>
//             </tr>
//           ))
//         ) : (
//           <tr>
//             <td colSpan={5}>
//               <div className="text-center">No records found</div>
//             </td>
//           </tr>
//         )}
//       </tbody>

//       {/* Modal for Viewing Log Details */}
//       <Modal show={showModal} onHide={handleCloseModal}>
//         <Modal.Header closeButton>
//           {/* <Modal.Title>Log Details</Modal.Title> */}
//         </Modal.Header>
//         <Modal.Body>
//           {selectedLog ? (
//             <>
//               <p>
//                 <strong>Log Data:</strong>
//               </p>
//               <div style={{ maxHeight: "450px", overflowY: "auto" }}>
//                 {renderKeyValuePairs(selectedLog.body || selectedLog.query)}
//               </div>
//             </>
//           ) : (
//             <p>No details available.</p>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleCloseModal}>
//             Close
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// };

// export default observer(LogTableBody);


import React, { useState } from "react";
import { observer } from "mobx-react";
import { toJS } from "mobx";
import { Modal, Button } from "react-bootstrap";
import * as XLSX from 'xlsx'; // Make sure to install xlsx package with: npm install xlsx

const LogTableBody = ({ logRaw, formId, approvalStatus}) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedLog, setSelectedLog] = useState(null);
  const logList = toJS(logRaw);



 
  const extractFieldNameAndValue = (log) => {
 

    // If log is null or undefined
    if (!log) {
      console.error('Log is null or undefined');
      return [];
    }

    // Check different possible locations for the data
    const possibleDataLocations = [
      log.body,  // This seems to be the key location in your current log structure
      log.data,
      log.request,
      log.query,
      log
    ];

    for (let dataSource of possibleDataLocations) {
 
      
      // If dataSource is an object with numeric keys (like your log)
      if (dataSource && typeof dataSource === 'object' && !Array.isArray(dataSource)) {
        const keys = Object.keys(dataSource);
        
        // Convert object to array if it looks like your log structure
        if (keys.every(key => !isNaN(Number(key)))) {
          const extractedData = keys.map(key => ({
            FieldName: dataSource[key].fieldName,
            Value: dataSource[key].value,
            Comment: dataSource[key].comment || '' // Add comment
          }));

       
          return extractedData;
        }
      }

      // Existing array check remains the same
      if (Array.isArray(dataSource)) {
        const extractedData = dataSource.map(item => ({
          FieldName: item.fieldName || item.FieldName || item.field_name,
          Value: item.value || item.Value || item.data,
          Comment: item.comment || item.Comment || '' // Add comment
        })).filter(item => item.FieldName);

        if (extractedData.length > 0) {
          return extractedData;
        }
      }
    }

    console.error('No suitable data found for export');
    return [];
  };

  // Function to export log data to Excel
  const exportToExcel = () => {
    try {
      // Ensure we have a selected log
      if (!selectedLog) {
        console.error('No log selected');
        alert('No log selected');
        return;
      }

      // Extract FieldName and Value from the selected log
      const excelData = extractFieldNameAndValue(selectedLog);

      // Ensure we have data to export
      if (excelData.length === 0) {
        console.error('No data to export');
        alert('No data found to export');
        return;
      }

      // Create worksheet
      const worksheet = XLSX.utils.json_to_sheet(excelData);

      // Create workbook and add worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Log Details");

      // Export to Excel file
      XLSX.writeFile(workbook, `log_details_export_${formId}.xlsx`);
    } catch (error) {
      console.error('Export failed:', error);
      alert('Failed to export data. Check console for details.');
    }
  };

  // Function to open modal and set selected log data
  const handleViewClick = (log) => {
    setSelectedLog(log);
    setShowModal(true);
  };

  // Function to close modal
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedLog(null);
  };

  // Function to render key-value pairs with proper design
  const renderKeyValuePairs = (data, level = 0) => {
    if (typeof data !== "object" || data === null) {
      return null;
    }

    return Object.entries(data).map(([key, value], index) => (
      <div
        key={index}
        style={{
          marginBottom: "10px",
          paddingLeft: `${level * 20}px`, // Indentation for nested objects
          borderLeft: level > 0 ? "1px solid #ccc" : "none", // Add border for nested levels
        }}
      >
        {!Number.isNaN(Number(key)) ? (
          <span style={{ display: "none" }}>
            {key.charAt(0).toUpperCase() + key.slice(1)}:
          </span>
        ) : (
          <strong>{key.charAt(0).toUpperCase() + key.slice(1)}:</strong>
        )}{" "}
        <div>
          {typeof value === "object" && value !== null ? (
            <div
              style={{
                backgroundColor: "#f8f9fa",
                padding: "10px",
                borderRadius: "5px",
              }}
            >
              {renderKeyValuePairs(value, level + 1)}{" "}
              {/* Recursively handle nested objects */}
            </div>
          ) : value !== null ? (
            value
          ) : (
            "null"
          )}
        </div>
      </div>
    ));
  };

  return (
    <>
      <tbody>
        {logList.length > 0 ? (
          logList.map((log, index) => (
            <tr key={index}>
              <td>{log.user.firstName}</td>
              <td>{new Date(log.createdAt).toLocaleDateString("en-GB")}</td>
              <td>{log.action}</td>
              <td>{log.ip}</td>
              <td>
                <button onClick={() => handleViewClick(log.request)}>
                  View
                </button>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={5}>
              <div className="text-center">No records found</div>
            </td>
          </tr>
        )}
      </tbody>

      {/* Modal for Viewing Log Details */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          {/* <Modal.Title>Log Details</Modal.Title> */}
        </Modal.Header>
        <Modal.Body>
          {selectedLog ? (
            <>
              <p>
                <strong>Log Data:</strong>
              </p>
              <div style={{ maxHeight: "450px", overflowY: "auto" }}>
                {renderKeyValuePairs(selectedLog.body || selectedLog.query)}
              </div>
            </>
          ) : (
            <p>No details available.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button 
            variant="success" 
            onClick={exportToExcel} 
            disabled={approvalStatus !== 'approved'}
            className="mr-2"
          >
            Download Excel
          </Button>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default observer(LogTableBody);
